// extracted by mini-css-extract-plugin
export var pillWrapper = "_q9-0";
export var showOverflow = "_q9-1";